var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEntraid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-fdd7680e-8ace-441a-8a3a-73410c3b1f21",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-38c07977-ab9a-48eb-a668-cda3102bbd85",
    x1: 7.697,
    y1: 779.168,
    x2: 14.082,
    y2: 786.631,
    gradientTransform: "translate(0 791.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#225086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0055c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-aed4a7bc-b380-4c34-b841-2d0f34d24f17",
    x1: 6.364,
    y1: 778.164,
    x2: 6.364,
    y2: 794.412,
    gradientTransform: "translate(0 791.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0294e4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-e2a7b7f2-bf16-4a76-ba27-7d149ab8a194",
    x1: 9.001,
    y1: 775.956,
    x2: 9.001,
    y2: 794.845,
    gradientTransform: "translate(0 791.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#44dbf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbf8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c67f3364-071c-41f9-a175-d3de1f837e0a",
    x1: 13.5,
    y1: 774.721,
    x2: 13.5,
    y2: 790.782,
    gradientTransform: "translate(0 791.516) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#041642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041642",
    stopOpacity: 0.25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17.647,9.906L10.147,1.445c-.599-.676-1.694-.676-2.294,0L.353,9.906c-.579.654-.428,1.641.323,2.111l7.499,4.688c.5.313,1.148.313,1.648,0l7.499-4.688c.751-.469.902-1.457.323-2.111h0Z",
    fill: "url(#uuid-38c07977-ab9a-48eb-a668-cda3102bbd85)",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.148,1.445c-.599-.676-1.694-.676-2.294,0L.354,9.906c-.579.654-.428,1.641.323,2.111,0,0,2.776,1.735,3.126,1.954.388.242,1.033.511,1.715.511.621,0,1.197-.18,1.676-.487,0,0,0,0,.002-.001l1.804-1.128-4.364-2.728,4.474-5.047c.55-.627,1.377-1.026,2.302-1.026.472,0,.917.107,1.314.292l-2.579-2.909v-.002Z",
    fill: "url(#uuid-aed4a7bc-b380-4c34-b841-2d0f34d24f17)",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.636 10.138 4.688 10.17 9.001 12.866 9.001 12.866 13.365 10.138 13.366 10.138 13.365 10.138 9.001 5.214 4.636 10.138",
    fill: "url(#uuid-e2a7b7f2-bf16-4a76-ba27-7d149ab8a194)",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.001,16.939c.287,0,.574-.078.824-.234l7.499-4.688c.751-.469.902-1.457.323-2.111L10.148,1.445c-.3-.338-.723-.507-1.147-.507v16.001Z",
    fill: "url(#uuid-c67f3364-071c-41f9-a175-d3de1f837e0a)",
    fillOpacity: 0.5,
    isolation: "isolate",
    opacity: 0.5,
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "uuid-f6648d86-048a-4f40-a6df-7ce120116a98",
    d: "m16.512,10.831c.464-.458.468-1.206.01-1.67-.003-.003-.006-.006-.01-.01h0l-2.035-2.035c-.461-.461-1.208-.461-1.669,0h0l-2.035,2.035c-.456.467-.456,1.213,0,1.679l1.7,1.7c.061.063.094.147.092.234v3.155c-.003.108.041.213.122.285l.773.773c.095.104.255.112.359.017.006-.005.012-.011.017-.017l.743-.743h0l.448-.448c.058-.059.058-.154,0-.214l-.316-.315c-.067-.059-.074-.162-.014-.23.005-.005.009-.01.014-.014l.316-.316c.059-.063.059-.161,0-.224l-.316-.316c-.065-.054-.073-.15-.019-.215.006-.007.012-.013.019-.019l.316-.326c.058-.059.058-.154,0-.214l-.448-.448v-.163l1.934-1.944Zm-2.87-3.226c.371,0,.672.301.672.672s-.301.672-.672.672-.672-.301-.672-.672h0c0-.371.301-.672.672-.672Z",
    fill: "#ffca00",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-e1697bf4-8e5d-4d62-90c9-6569d79d4944",
    d: "m13.133,16.042h0c.055.057.145.058.201.003.031-.03.047-.072.043-.115v-2.605c.002-.051-.021-.1-.061-.132h0c-.064-.045-.153-.03-.199.034-.02.029-.029.064-.025.098v2.555c-.02.058-.004.122.041.163Z",
    fill: "#ff9300",
    isolation: "isolate",
    opacity: 0.75,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "uuid-c930d4c2-9f41-48c7-adf7-acbd73af6fbf",
    x: 12.014,
    y: 9.834,
    width: 3.348,
    height: 0.397,
    rx: 0.183,
    ry: 0.183,
    fill: "#ff9300",
    isolation: "isolate",
    opacity: 0.75,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "uuid-755aaa46-8b89-45f5-9da0-8a42782c5ddd",
    x: 12.014,
    y: 10.475,
    width: 3.348,
    height: 0.397,
    rx: 0.183,
    ry: 0.183,
    fill: "#ff9300",
    isolation: "isolate",
    opacity: 0.75,
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntraid);
export default __webpack_public_path__ + "static/media/entraid.b4e3c1576262e70e083eb2d9fc78f5c6.svg";
export { ForwardRef as ReactComponent };